import React, { useState, useEffect, useContext } from 'react';
import './CorporationManagement.css';
import CorporationRow from '../CorporationRow/CorporationRow';
import InteractiveList from '../InteractiveList/InteractiveList';
import ListUpdateMessage from '../ListUpdateMessage/ListUpdateMessage';
import { AdminContext } from '../../contexts/AdminContext';
import logComponent from '../../common/logComponent';

export default function CorporationManagement({ isLoading, isError,  reload, showCorporationDetail, updatedCorporation } ) {
  const adminContext = useContext(AdminContext);
  const [lastMessageUpdate, setLastMessageUpdate] = useState(null);
  const { corporations } = adminContext;

  if (logComponent('CorporationManagement')) { console.debug('CorporationManagement rendered'); }

  useEffect(() => {
    if (logComponent('CorporationManagement')) { console.debug('CorporationManagement useEffect [updatedCorporation]'); }
    setLastMessageUpdate(Date.now());
  }, [updatedCorporation]);

  return (
    <div className="Corporation-Management">
    {
      updatedCorporation &&
      <ListUpdateMessage
        message={`${updatedCorporation.name} logo has been updated`}
        lastUpdate={ lastMessageUpdate }
          />
    }        
      <InteractiveList  
        columns={[
          { name: 'Name', sortField: 'Name' },
          { name: 'Status' , style: { width: '30%' }, hideAt: 'sm' },
          { name: '', style: { width: '64px'}}
        ]}
        searchTextFields={['name','postalCode']}
        searchPlaceholder="Search corporations" 
        defaultSortField="Name"
        /* TODO: Uncomment Status filter when data is available */
        filters={[
          /*{
            title: 'Status',
            type: 'checkbox',
            name: 'status',
            options: [
              {
                text: 'Active',
                criteria: []
              }, {
                text: 'Inactive',
                criteria: []
              }
            ]
          },*/ {
            title: 'Industry type',
            type: 'checkbox',
            name: 'industryType',
            options: [
              {
                text: 'CCRC',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['CCRC']
                }]
              },
              {
                text: 'Long Term Care',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Long Term Care']
                }]
              },
              {
                text: 'Healthcare',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Healthcare']
                }]
              },
              {
                text: 'Hotel/Hospitality',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Hotel/Hospitality']
                }]
              }, 
              {
                text: 'Government',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Government']
                }]
              },
              {
                text: 'Education',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Education']
                }]
              }
            ]
          }           
        ]}
        singularItemTerm="corporation"
        pluralItemTerm="corporations"
        items={corporations}
        itemsLoading={isLoading}
        itemsError={isError}
        rowComponent={CorporationRow}
        showDetail={showCorporationDetail}
        keyField="salesforceAccountId"
        reloadAction={reload}
      />
    </div>
  );
}